import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import Button from '../../components/BaseComponents/Button';
import {
  changeModalVisibility,
} from '../../store/membersSlice';
import MembersModal from '../../components/Members/MembersModal';
import FilterIcon from '../../assets/icons/filter-b.svg';
import { 
  bulkAddMembers,
  getDoctorsMembersList, 
  getMembersList, 
  getNutritionistsMembersList,
  getActiveMembersList,
  getDisabledMembersList,

  getAllMembersList,
  getBloodIncompleteBookingMembersList,
  getFreeMembersList,
  getOnboardingData,
  getScanIncompleteBookingMembersList,
  getInChargeAdminList,
} from '../../api/members';
import MembersTable from '../../components/Members/MembersTable';
import Loader from '../../components/BaseComponents/Loader';
import { UserRoleEnum, ListMembersResponseElement, ListMembersResponse } from '../../types/apiGeneratedTypes';
import './Members.scss';
import Modal from '../../components/BaseComponents/Modal';
import CSVUploadModal from '../../components/Members/CSVUploadModal';
import MergeProfilesModal from '../../components/Members/MergeProfilesModal';
import { parseFile } from '../../utils/csvParser';
import { toast } from 'react-toastify';
import deleteIcon from '../../assets/icons/Thrash-bin-grey.svg';
import Select, { SelectOption } from '../../components/BaseComponents/Select';
import { getTagsList } from '../../api/tags';
import DatePickerComp from '../../components/BaseComponents/DatePicker';
import { getDoctorsList } from '../../api/doctors';
import { isAfter, isBefore, startOfDay } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

const isSuperAdminUser = (admin: RootState['admin']['admin']) =>
  admin.role === UserRoleEnum.SuperAdmin && admin.is_super_admin === true;

type TabType =
  | 'active'
  | 'disabled'
  | 'free'
  | 'all'
  | 'custom-inqurries-blood'
  | 'custom-inqurries-body-scan';

const membershipStatusOptions = [
  { key: 'all', value: 'All Statuses' },
  { key: 'user_added', value: 'User Added' },
  { key: 'user_paid', value: 'User Paid' },
  { key: 'member_active', value: 'Member Active' },
  { key: 'tuli_appt_booked', value: 'Tuli Appt Booked' },
  { key: 'tuli_appt_complete', value: 'Tuli Appt Complete' },
  { key: 'sample_received', value: 'Sample Received' },
  { key: 'report_available', value: 'Report Available' },
  { key: 'report_awaiting_review_by_gp', value: 'Report Awaiting Review By GP' },
  { key: 'report_awaiting_discussion', value: 'Report Awaiting Discussion' },
  { key: 'gp_review_booked', value: 'GP Review Booked' },
  { key: 'report_published', value: 'Report Published' },
  { key: 'nutritionist_appt_invite_sent', value: 'Nutritionist Appt Invite Sent' },
  { key: 'nutritionist_appt_booked', value: 'Nutritionist Appt Booked' },
  { key: 'care_notes_uploaded', value: 'Care Notes Uploaded' },
  { key: 'recommendations_uploaded', value: 'Recommendations Uploaded' },
  { key: 'supplements_uploaded', value: 'Supplements Uploaded' },
  { key: 'home_blood_appt_requested', value: 'Home Blood Appt Requested'},
  { key: 'home_blood_appt_booked', value: 'Home Blood Appt Booked'},
  { key: 'home_blood_appt_complete', value: 'Home Blood Appt Complete' },
  { key: 'scan_scheduled', value: 'Scan Scheduled' },
  { key: 'scan_complete', value: 'Scan complete' },
  { key: 'scan_review_invite_sent', value: 'Scan review invite sent' },
  { key: 'mri_scan_published', value: 'MRI Scan published' },
  { key: 'testing_complete_feedback', value: 'Testing complete feedback' },
  { key: 'pre_scan_consult_invite_sent', value: 'Pre-scan consultation invite sent' },
  { key: 'pre_scan_consult_booked', value: 'Pre-scan consultation booked' },
  { key: 'pre_scan_questionnaire_link_sent', value: 'Pre-scan questionnaire link sent' },
  { key: 'pre_scan_questionnaire_submitted', value: 'Pre-scan questionnaire submitted' },
  { key: 'subscription_cancelled', value: 'Subscription Cancelled' }
];

const planFilterOptions = [
  { key: 'all', value: 'All Plans' },
  { key: 'core', value: 'Core' },
  { key: 'scan', value: 'Scan' },
  { key: 'plus', value: 'Plus' },
];

const CSVModal = ({ onClose, csvMembers, setCsvMembers,setTotalCount }: { onClose: () => void, csvMembers: any, setCsvMembers: (members: any[]) => void ,setTotalCount: (total_count: number|string) => void}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const handleAddMembers = async () => {
    try {
      setIsLoading(true);
      const response = await bulkAddMembers(csvMembers);
      if (response) {
        if (response.failed_count > 0) {
          toast.error(`${response.failed_count} members failed to create.`);
        } else {
          toast.success('All members created successfully.');
        }
      }
      onClose();
    } catch (err: any) {
      toast.error('Failed to add members. Please try again.');
    } finally {
      setIsLoading(false);
      let member = await getMembersList(0, 10);
      if(member) setTotalCount(typeof member.total_count === 'number' ? member.total_count : 0)
    }
  };

  const handleDeleteMember = (index: number) => {
    if (isLoading) return; 
    const updatedMembers = csvMembers.filter((_: any, i: number) => i !== index);
    setCsvMembers(updatedMembers);
    
    if (updatedMembers.length === 0) {
      onClose();
    }
  };

 const formatDate = (isoString: string): string => {
  if (!isoString) return '';

  const date = new Date(isoString);
  const year = date.getUTCFullYear();
  const month = `${date.getUTCMonth() + 1}`.padStart(2, '0');
  const day = `${date.getUTCDate()}`.padStart(2, '0');
  const hours = `${date.getUTCHours()}`.padStart(2, '0');
  const minutes = `${date.getUTCMinutes()}`.padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

  return (
    <Modal
    isOpen={true}
    onClose={onClose}
    title={`${csvMembers.length} members imported`}
    width='900px'>
    <div className='table-style' >
    <table>
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Expiration date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>

           {csvMembers.map((member:any, index:number) => (
              <tr key={index}>
                <td>{member.first_name || ''}</td>
                <td>{member.last_name || ''}</td>
                <td>{member.email || ''}</td>
                <td>{member.phone || ''}</td>
                <td>{formatDate(member.subscription_end)}</td>
                <td>
                  <button 
                    className={`delete-button ${isLoading ? 'disabled' : ''}`}
                    onClick={() => handleDeleteMember(index)}
                    disabled={isLoading}
                  >
                    <img src={deleteIcon} alt="delete" />
                    <p>Delete</p>
                  </button>
                </td>
              </tr>
            ))}
            
          </tbody>
        </table>
    </div>
      <Button text={`Add ${csvMembers.length} members`}  isDisabled={csvMembers.length === 0} onClick={handleAddMembers} isLoading={isLoading}/>
    </Modal>
  )
}
const Members: React.FC = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [isSearching, setIsSearching] = React.useState<boolean>(false);
  const [error, setError] = React.useState<any>(null);
  const [allMembersKey, setAllMembersKey] = React.useState<number>(0);
  const [disabledMembersKey, setDisabledMembersKey] = React.useState<number>(0);

  const [freeMembersKey, setFreeMembersKey] = React.useState<number>(0);
  const [activeTab, setActiveTab] = useState<TabType>('active');
  const [allMembers, setAllMembers] = useState<ListMembersResponseElement[]>([]);
  const [totalCount, setTotalCount] = useState<number | string>(0);
  const [tabCounts, setTabCounts] = useState<{
    active: number;
    disabled: number;
    free: number;
    all: number;
    customInquiriesBlood: number;
    customInquiriesBodyScan: number;
  }>({
    active: 0,
    disabled: 0,
    free: 0,
    all: 0,
    customInquiriesBlood: 0,
    customInquiriesBodyScan: 0,
  });

  const [disabledMembers, setDisabledMembers] = useState<ListMembersResponseElement[]>([]);

  const [freeMembers, setFreeMembers] = useState<ListMembersResponseElement[]>([]);
  const { isAddMemberModalOpened, limit, sortKey, sortOrder } = useSelector(
    (state: RootState) => state.members
  );
  const { admin } = useSelector((state: RootState) => state.admin);
  const { role } = admin;
  const canMergeProfiles = isSuperAdminUser(admin);
  
  const showTabs = role !== UserRoleEnum.Doctor && role !== UserRoleEnum.Nutritionist;
  const [doctorTab, setDoctorTab] = useState<'all-members' | 'my-members'>('all-members');
  const [searchQuery, setSearchQuery] = useState<string>('');
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [isCSVUploadModalOpened, setIsCSVUploadModalOpened] = useState<boolean>(false);
  const [isMergeProfilesModalOpened, setIsMergeProfilesModalOpened] = useState<boolean>(false);
  const [isCSVPreviewModalOpened, setIsCSVPreviewModalOpened] = useState<boolean>(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState<boolean>(false);
  const [csvMembers, setCsvMembers] = useState<any[]>([]);
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState<{ key: string; value: string }>({ key: 'all', value: 'All Statuses' });
  const [selectedPlanFilter, setSelectedPlanFilter] = useState<{ key: string; value: string }>({
    key: 'all',
    value: 'All Plans',
  });
  const [selectedInchargeFilter, setSelectedInchargeFilter] = useState<SelectOption>({
    key: 'all',
    value: 'All Incharge',
  });
  const [inchargeFilterOptions, setInchargeFilterOptions] = useState<SelectOption[]>([
    { key: 'all', value: 'All Incharge' },
  ]);
  const [selectedDoctorFilter, setSelectedDoctorFilter] = useState<SelectOption>({
    key: 'all',
    value: 'Assign Doctor',
  });
  const [doctorFilterOptions, setDoctorFilterOptions] = useState<SelectOption[]>([
    { key: 'all', value: 'Assign Doctor' },
  ]);
  const [selectedTagFilter, setSelectedTagFilter] = useState<SelectOption>({
    key: 'all',
    value: 'All Tags',
  });
  const [tagFilterOptions, setTagFilterOptions] = useState<SelectOption[]>([
    { key: 'all', value: 'All Tags' },
  ]);
  const [subscriptionStartDate, setSubscriptionStartDate] = useState<Date | null>(null);
  const [subscriptionEndDate, setSubscriptionEndDate] = useState<Date | null>(null);
  const isInitialSearchEffect = useRef<boolean>(true);
  const previousSearchQueryRef = useRef<string>('');
  const SEARCH_DEBOUNCE_MS = 600;
  const MIN_SEARCH_CHARS = 2;

  const subscriptionStartDateParam = subscriptionStartDate
    ? formatInTimeZone(
        subscriptionStartDate,
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        'yyyy-MM-dd'
      )
    : undefined;
  const subscriptionEndDateParam = subscriptionEndDate
    ? formatInTimeZone(
        subscriptionEndDate,
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        'yyyy-MM-dd'
      )
    : undefined;

  const subscriptionToday = startOfDay(new Date());

  const handleSubscriptionStartDateChange = (date: Date | null) => {
    if (!date) {
      setSubscriptionStartDate(null);
      return;
    }

    const selectedDay = startOfDay(date);

    if (isAfter(selectedDay, subscriptionToday)) {
      toast.error('Start date cannot be in the future.');
      return;
    }

    if (subscriptionEndDate && isAfter(selectedDay, startOfDay(subscriptionEndDate))) {
      toast.error('Start date cannot be after end date.');
      return;
    }

    setSubscriptionStartDate(date);
  };

  const handleSubscriptionEndDateChange = (date: Date | null) => {
    if (!date) {
      setSubscriptionEndDate(null);
      return;
    }

    const selectedDay = startOfDay(date);

    if (isAfter(selectedDay, subscriptionToday)) {
      toast.error('End date cannot be in the future.');
      return;
    }

    if (subscriptionStartDate && isBefore(selectedDay, startOfDay(subscriptionStartDate))) {
      toast.error('End date cannot be before start date.');
      return;
    }

    setSubscriptionEndDate(date);
  };

  const defaultStatusFilter = { key: 'all', value: 'All Statuses' };
  const defaultPlanFilter = { key: 'all', value: 'All Plans' };
  const defaultInchargeFilter: SelectOption = { key: 'all', value: 'All Incharge' };
  const defaultDoctorFilter: SelectOption = { key: 'all', value: 'Assign Doctor' };
  const defaultTagFilter: SelectOption = { key: 'all', value: 'All Tags' };
  const hasActiveFilters =
    searchQuery.trim() !== '' ||
    selectedStatusFilter.key !== 'all' ||
    selectedInchargeFilter.key !== 'all' ||
    selectedPlanFilter.key !== 'all' ||
    selectedDoctorFilter.key !== 'all' ||
    selectedTagFilter.key !== 'all' ||
    subscriptionStartDate !== null ||
    subscriptionEndDate !== null;

  const handleResetFilters = () => {
    previousSearchQueryRef.current = '';
    setSearchQuery('');
    setSelectedStatusFilter(defaultStatusFilter);
    setSelectedPlanFilter(defaultPlanFilter);
    setSelectedInchargeFilter(defaultInchargeFilter);
    setSelectedDoctorFilter(defaultDoctorFilter);
    setSelectedTagFilter(defaultTagFilter);
    setSubscriptionStartDate(null);
    setSubscriptionEndDate(null);
  };

  const handleCSVFileUpload = async (file: File) => {
    try {
      const parseResult = await parseFile(file);

      if (!parseResult.success) {
        toast.error('File parsing failed: ' + parseResult.errors.join(', '));
        return;
      }

      if (parseResult.data.length === 0) {
        toast.error('No valid members found in file');
        return;
      }

      setCsvMembers(parseResult.data);
      setIsCSVUploadModalOpened(false);
      setIsCSVPreviewModalOpened(true);

      if (parseResult.errors.length > 0) {
        toast.warning(`File parsed with ${parseResult.errors.length} warnings. Check the preview.`);
      }
    } catch (error) {
      console.error('Error reading file:', error);
      toast.error('Failed to read file');
    }
  };

  const fetchMembers = useCallback(async (search?: string, isSearch: boolean = false) => {
    try {
      setError(null);
      if (isSearch) {
        setIsSearching(true);
      } else {
        setLoading(true);
      }
      
      const membershipStatus = selectedStatusFilter.key !== 'all' ? selectedStatusFilter.key : undefined;
      const inChargeAdminName =
        selectedInchargeFilter.key !== 'all'
          ? String(selectedInchargeFilter.value).replace(/\s+/g, ' ').trim()
          : undefined;
      const assignedDoctorId =
        selectedDoctorFilter.key !== 'all'
          ? String(selectedDoctorFilter.key).trim()
          : undefined;
      const membershipType =
        activeTab === 'active' && selectedPlanFilter.key !== 'all'
          ? selectedPlanFilter.key
          : undefined;
      const tagIdFilter =
        selectedTagFilter.key !== 'all'
          ? Number(selectedTagFilter.key)
          : undefined;
      const searchValue = search || '';

      let membersList: ListMembersResponse | undefined;
      if (role === UserRoleEnum.Doctor) {
        const memberStatus = doctorTab === 'my-members' ? 'my_members' : 'all_members';
        membersList = await getDoctorsMembersList(0, limit, searchValue, 'with_doctor', sortOrder, sortKey || undefined, memberStatus);
      } else if (role === UserRoleEnum.Nutritionist) {
        membersList = await getNutritionistsMembersList(0, limit, searchValue, 'with_nutritionist', sortOrder, sortKey || undefined);
      } else {
        switch (activeTab) {
          case 'active':
            membersList = await getActiveMembersList(0, limit, searchValue, 'with_doctor_and_nutritionist', sortOrder, sortKey || undefined, membershipStatus, inChargeAdminName, membershipType, assignedDoctorId, subscriptionStartDateParam, subscriptionEndDateParam, tagIdFilter);
            break;
          case 'disabled':
            membersList = await getDisabledMembersList(0, limit, searchValue, 'with_doctor_and_nutritionist', sortOrder, sortKey || undefined, membershipStatus, inChargeAdminName, undefined, assignedDoctorId, subscriptionStartDateParam, subscriptionEndDateParam, tagIdFilter);
            break;

          case 'free':
            membersList = await getFreeMembersList(0, limit, searchValue, 'with_doctor_and_nutritionist', sortOrder, sortKey || undefined, membershipStatus, inChargeAdminName, undefined, assignedDoctorId, subscriptionStartDateParam, subscriptionEndDateParam, tagIdFilter);
            break;
          case 'all':
            membersList = await getAllMembersList(0, limit, searchValue, 'with_doctor_and_nutritionist', sortOrder, sortKey || undefined, membershipStatus, inChargeAdminName, undefined, assignedDoctorId, subscriptionStartDateParam, subscriptionEndDateParam, tagIdFilter);
            break;
          case 'custom-inqurries-blood':
            membersList = await getBloodIncompleteBookingMembersList(0, limit, searchValue, 'with_doctor_and_nutritionist', sortOrder, sortKey || undefined, membershipStatus, inChargeAdminName, undefined, assignedDoctorId, subscriptionStartDateParam, subscriptionEndDateParam, tagIdFilter);
            break;
          case 'custom-inqurries-body-scan':
            membersList = await getScanIncompleteBookingMembersList(0, limit, searchValue, 'with_doctor_and_nutritionist', sortOrder, sortKey || undefined, membershipStatus, inChargeAdminName, undefined, assignedDoctorId, subscriptionStartDateParam, subscriptionEndDateParam, tagIdFilter);
            break;
          default:
            membersList = await getActiveMembersList(0, limit, searchValue, 'with_doctor_and_nutritionist', sortOrder, sortKey || undefined, membershipStatus, inChargeAdminName, membershipType, assignedDoctorId, subscriptionStartDateParam, subscriptionEndDateParam, tagIdFilter);
        }
      }

      const count = membersList?.total_count ?? membersList?.members?.length ?? 0;
      setTotalCount(count);

      if (membersList?.active_count !== undefined || membersList?.disabled_count !== undefined ||
          membersList?.free_count !== undefined || membersList?.all_count !== undefined || 
          membersList?.scan_count !== undefined || membersList?.blood_count !== undefined) {
        setTabCounts(prev => ({
          active: membersList?.active_count ?? prev.active,
          disabled: membersList?.disabled_count ?? prev.disabled,
          free: membersList?.free_count ?? prev.free,
          all: membersList?.all_count ?? prev.all,
          customInquiriesBlood: membersList?.blood_count??prev.customInquiriesBlood,
          customInquiriesBodyScan: membersList?.scan_count??prev.customInquiriesBodyScan,
        }));
      }

      // These two "Customer inquiries" tabs have their own counts which were being
      // refreshed on every search. That causes extra requests with
      // member_status=scan_incomplete_booking / blood_incomplete_booking even when
      // you're searching within the Active tab.
      // Only refresh those counts when not actively searching.
      
      if (role === UserRoleEnum.Doctor || role === UserRoleEnum.Nutritionist) {
        setAllMembers(membersList.members);
        setAllMembersKey(prev => prev + 1);
      } else {
        switch (activeTab) {
          case 'active':
            setAllMembers(membersList.members);
            setAllMembersKey(prev => prev + 1);
            break;
          case 'disabled':
            setDisabledMembers(membersList.members);
            setDisabledMembersKey(prev => prev + 1);
            break;

          case 'free':
            setFreeMembers(membersList.members);
            setFreeMembersKey(prev => prev + 1);
            break;
          case 'all':
            setAllMembers(membersList.members);
            setAllMembersKey(prev => prev + 1);
            break;
          case 'custom-inqurries-blood':
            setAllMembers(membersList.members);
            setAllMembersKey(prev => prev + 1);
            break;
          case 'custom-inqurries-body-scan':
            setAllMembers(membersList.members);
            setAllMembersKey(prev => prev + 1);
            break;
        }
      }
    } catch (error) {
      setError(error);
    } finally {
      if (isSearch) {
        setIsSearching(false);
      } else {
        setLoading(false);
      }
    }
  }, [
    activeTab,
    doctorTab,
    limit,
    role,
    selectedDoctorFilter,
    selectedInchargeFilter,
    selectedPlanFilter,
    selectedStatusFilter,
    selectedTagFilter,
    sortKey,
    sortOrder,
    subscriptionEndDateParam,
    subscriptionStartDateParam,
  ]);

  const fetchMembersRef = useRef(fetchMembers);
  fetchMembersRef.current = fetchMembers;
  const searchQueryRef = useRef(searchQuery);
  searchQueryRef.current = searchQuery;

  const handleTabChange = (tab: TabType) => {
    if (tab === activeTab) {
        return;
      }
    setActiveTab(tab);
    // Retain search text when switching tabs.
    // Clear all member states
    setAllMembers([]);

    setDisabledMembers([]);

    setFreeMembers([]);

    switch (tab) {
      case 'active':
        setAllMembersKey(prev => prev + 1);
        break;
      case 'disabled':
        setDisabledMembersKey(prev => prev + 1);
        break;

      case 'free':
        setFreeMembersKey(prev => prev + 1);
        break;
      case 'all':
        setAllMembersKey(prev => prev + 1);
        break;
      case 'custom-inqurries-blood':
        setAllMembersKey(prev => prev + 1);
        break;
      case 'custom-inqurries-body-scan':
        setAllMembersKey(prev => prev + 1);
        break;
    }
  };

  const handleDoctorTabChange = (tab: 'all-members' | 'my-members') => {
    setDoctorTab(tab);
    // Retain search text when switching tabs.
    setAllMembers([]);
    setAllMembersKey(prev => prev + 1);
  };
  const uploadData = async (): Promise<void> => {
    try {
      setIsExporting(true);
      const blob = await getOnboardingData();
      
      if (!blob || blob.size === 0) {
        toast.error('No data available to export');
        return;
      }
      
      const textData = await blob.text();
      
      if (!textData || textData.trim() === '') {
        toast.error('No data available to export');
        return;
      }
      
      const convertToCSV = (data: any[]): string => {
        if (!data || !Array.isArray(data) || data.length === 0) {
          return "";
        }
        
        const flattenObject = (obj: any): Record<string, any> => {
          const flattened: Record<string, any> = {};
          
          if (obj === null || obj === undefined) {
            return flattened;
          }
          
          for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
              const value = obj[key];
              
              if (value === null || value === undefined) {
                flattened[key] = '';
              } else if (Array.isArray(value)) {
                if (value.length === 0) {
                  flattened[key] = '';
                } else {
                  flattened[key] = value.map(v => {
                    if (v === null || v === undefined) return '';
                    if (typeof v === 'object') return JSON.stringify(v);
                    return String(v);
                  }).join('; ');
                }
              } else if (typeof value === 'object' && !(value instanceof Date)) {
                const nested = flattenObject(value);
                Object.assign(flattened, nested);
              } else {
                if (value instanceof Date) {
                  flattened[key] = value.toISOString();
                } else {
                  flattened[key] = value;
                }
              }
            }
          }
          
          return flattened;
        };
        
        const allKeys = new Set<string>();
        const flattenedData = data.map(obj => {
          const flattened = flattenObject(obj);
          Object.keys(flattened).forEach(k => allKeys.add(k));
          return flattened;
        });
        
        const keysArray = Array.from(allKeys).sort();
        const priorityKeys = ['member_id', 'first_name', 'last_name'];
        const keys: string[] = [];
        
        priorityKeys.forEach(key => {
          if (keysArray.includes(key)) {
            keys.push(key);
          }
        });
        
        const remainingKeys = keysArray.filter(k => !priorityKeys.includes(k));
        keys.push(...remainingKeys);
        
        const header = keys.map(k => `"${k}"`).join(",") + "\n";
        
        const rows = flattenedData.map(flattened => {
          return keys.map(key => {
            const value = flattened[key] ?? '';
            const stringValue = String(value);
            const escapedValue = stringValue.replace(/"/g, '""');
            return `"${escapedValue}"`;
          }).join(",");
        }).join("\n");
        
        return header + rows;
      };
      
      let csvText: string;
      try {
        const jsonData = JSON.parse(textData);
        
        let dataArray: any[] = [];
        
        if (Array.isArray(jsonData)) {
          dataArray = jsonData;
        } else if (jsonData && typeof jsonData === 'object') {
          if (jsonData.members && Array.isArray(jsonData.members)) {
            dataArray = jsonData.members;
          } else if (jsonData.data && Array.isArray(jsonData.data)) {
            dataArray = jsonData.data;
          } else if (jsonData.results && Array.isArray(jsonData.results)) {
            dataArray = jsonData.results;
          } else {
            dataArray = [jsonData];
          }
        }
        
        if (!dataArray || dataArray.length === 0) {
          toast.error('No member data found to export');
          return;
        }
        
        csvText = convertToCSV(dataArray);
      } catch (parseError) {
        csvText = textData;
      }
      
      if (!csvText || csvText.trim() === '') {
        toast.error('No data available to export');
        return;
      }
      
      const BOM = "\uFEFF";
      const formattedCsv = BOM + csvText;
      
      const csvBlob = new Blob([formattedCsv], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(csvBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `onboarding-data-${new Date().toISOString().split("T")[0]}.csv`;
      document.body.appendChild(link);
      link.click();
      
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      
      toast.success('Onboarding data exported successfully');
    } catch (error: any) {
      let errorMessage = 'Failed to export onboarding data';
      
      if (error?.response?.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          const errorJson = JSON.parse(errorText);
          errorMessage = errorJson.detail || errorMessage;
        } catch {
          errorMessage = 'Failed to export onboarding data';
        }
      } else if (error?.response?.data?.detail) {
        errorMessage = error.response.data.detail;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      
      toast.error(errorMessage);
    } finally {
      setIsExporting(false);
    }
  }
  useEffect(() => {
    if (isInitialSearchEffect.current) {
      isInitialSearchEffect.current = false;
      previousSearchQueryRef.current = searchQuery;
      return;
    }

    const prevQuery = previousSearchQueryRef.current;
    previousSearchQueryRef.current = searchQuery;

    const trimmed = searchQuery.trim();
    const prevTrimmed = prevQuery.trim();

    // Don't spam API for empty/whitespace-only changes.
    if (!trimmed && !prevTrimmed) {
      return;
    }

    // Avoid firing API calls for very short queries.
    // Still allow clearing the search to reload full list.
    if (trimmed && trimmed.length < MIN_SEARCH_CHARS) {
      return;
    }

    const timeoutId = setTimeout(() => {
      fetchMembersRef.current(searchQuery, true);
    }, SEARCH_DEBOUNCE_MS);

    return () => clearTimeout(timeoutId);
  }, [searchQuery]);

  useEffect(() => {
    if (role === UserRoleEnum.Doctor || role === UserRoleEnum.Nutritionist) {
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await getInChargeAdminList();
        if (cancelled) return;
        const adminOpts: SelectOption[] = [
          { key: 'all', value: 'All Incharge' },
          ...(res?.admins ?? [])
            .map((a) => ({
              key: (a.user_id ?? a.id ?? '') as string,
              value: `${a.first_name} ${a.last_name}`.trim(),
            }))
            .filter((o) => o.key),
        ];
        setInchargeFilterOptions(adminOpts);
      } catch (e) {
        console.error(e);
        if (!cancelled) {
          toast.error('Could not load Incharge filter options. Refresh the page or try again later.');
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [role]);

  useEffect(() => {
    if (role === UserRoleEnum.Doctor || role === UserRoleEnum.Nutritionist) {
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const response = await getDoctorsList(0, 500);
        if (cancelled) return;
        const doctorOptions: SelectOption[] = [
          { key: 'all', value: 'Assign Doctor' },
          ...((response?.doctors ?? []) as any[])
            .map((doctor) => ({
              key: (doctor.user_id ?? doctor.id ?? '').toString(),
              value: `${doctor.first_name ?? ''} ${doctor.last_name ?? ''}`.replace(/\s+/g, ' ').trim(),
            }))
            .filter((option) => option.key && option.value),
        ];
        setDoctorFilterOptions(doctorOptions);
      } catch (error) {
        console.error(error);
        if (!cancelled) {
          toast.error('Could not load doctor filter options. Refresh the page or try again later.');
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [role]);

  useEffect(() => {
    if (role === UserRoleEnum.Doctor || role === UserRoleEnum.Nutritionist) {
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const response = await getTagsList();
        if (cancelled) return;
        const tagOptions: SelectOption[] = [
          { key: 'all', value: 'All Tags' },
          ...(response?.tags ?? [])
            .filter((tag) => tag.is_active !== false && tag.id != null)
            .map((tag) => ({
              key: String(tag.id),
              value: tag.name,
            })),
        ];
        setTagFilterOptions(tagOptions);
      } catch (error) {
        console.error(error);
        if (!cancelled) {
          toast.error('Could not load tag filter options. Refresh the page or try again later.');
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [role]);

  useEffect(() => {
    fetchMembers(searchQueryRef.current);
  }, [fetchMembers]);

  const getCountText = () => {
    if (!showTabs) {
      return `${totalCount} ${totalCount === 1 ? 'Member' : 'Members'}`;
    }

    const countText = `${totalCount} ${totalCount === 1 ? 'Member' : 'Members'}`;
    switch (activeTab) {
      case 'active':
        return `${countText} Active`;
      case 'disabled':
        return `${countText} Disabled`;
      case 'free':
        return `${countText} Free`;
      case 'all':
        return countText;
      case 'custom-inqurries-blood':
        return countText;
      case 'custom-inqurries-body-scan':
        return countText;
      default:
        return countText;
    }
  };


  if (loading && allMembers.length === 0 && !error) return <Loader />;
  if (error) {
    return (
      <div className="page-container">
        <p style={{ color: '#374151', marginBottom: 16 }}>We could not load the members list.</p>
        <Button
          text="Retry"
          onClick={() => {
            setError(null);
            fetchMembers(searchQuery);
          }}
        />
      </div>
    );
  }

  return (
    <div className='page-container'>
      <div className='search-row-container sideBarPad'>
        {role === UserRoleEnum.Doctor || role === UserRoleEnum.Nutritionist ? (
          <div className='search-and-filter-container members-top-filters'>
            <div className='members-search-filters-row members-search-filters-row--with-count'>
              <div className="search-input-container">
                <input
                  type="text" 
                  className="search-input"
                  placeholder="Search by name, email, or phone number"
                  ref={searchInputRef}
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      fetchMembers(searchQuery, true);
                    }
                  }}
                />
                <button
                  className="search-button"
                  onClick={() => fetchMembers(searchQuery, true)}
                  disabled={isSearching}
                >
                  {isSearching ? 'Searching...' : 'Search'}
                </button>
              </div>
              <div className='count-container'>
                {getCountText()}
              </div>
            </div>
          </div>
        ) : (
          <div className='members-filters-panel'>
            <div className='members-search-filters-row members-search-filters-row--admin'>
              <div className="search-input-container">
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search by name, email, or phone number"
                  ref={searchInputRef}
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      fetchMembers(searchQuery, true);
                    }
                  }}
                />
                <button
                  className="search-button"
                  onClick={() => fetchMembers(searchQuery, true)}
                  disabled={isSearching}
                >
                  {isSearching ? 'Searching...' : 'Search'}
                </button>
              </div>
            </div>
          </div>
        )}
        <div className='members-actions-buttons d-flex align-items-center gap-20'>
          <Button
            isSecondary={true}
            text='Add Member'
            onClick={() => dispatch(changeModalVisibility(true))}
          />
        </div>
      </div>

      {role !== UserRoleEnum.Doctor && role !== UserRoleEnum.Nutritionist && (
        <div className='members-actions-row'>
          <div className='count-container members-count-inline'>
            {getCountText()}
            <button
              type='button'
              className='members-filter-trigger-button'
              onClick={() => setIsFilterModalOpen(true)}
            >
              <img alt='Filter' src={FilterIcon} width={16} height={16} />Filter
            </button>
          </div>
          
        </div>
      )}

      <Modal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        title='Filter Members'
        width='420px'
        closeOnOverlayClick={true}
        closeOnEsc={true}
      >
        <div className='members-filter-modal-content'>
          <div className='members-filter-modal-field'>
            <Select
              name='membership_status_filter'
              placeholder='Filter by status'
              selectedOption={selectedStatusFilter}
              options={membershipStatusOptions}
              onChange={(option) => {
                setSelectedStatusFilter(option);
              }}
              isError={false}
              useMenuPortal={true}
            />
          </div>
          <div className='members-filter-modal-field'>
            <Select
              name='incharge_filter'
              placeholder='All Incharge'
              selectedOption={selectedInchargeFilter}
              options={inchargeFilterOptions}
              onChange={(option) => {
                setSelectedInchargeFilter(option);
              }}
              isError={false}
              useMenuPortal={true}
            />
          </div>
          {activeTab === 'active' && (
            <div className='members-filter-modal-field'>
              <Select
                name='plan_filter'
                placeholder='All Plans'
                selectedOption={selectedPlanFilter}
                options={planFilterOptions}
                onChange={(option) => {
                  setSelectedPlanFilter(option);
                }}
                isError={false}
                useMenuPortal={true}
              />
            </div>
          )}
          <div className='members-filter-modal-field'>
            <Select
              name='doctor_filter'
              placeholder='Assign Doctor'
              selectedOption={selectedDoctorFilter}
              options={doctorFilterOptions}
              onChange={(option) => {
                setSelectedDoctorFilter(option);
              }}
              isError={false}
              useMenuPortal={true}
            />
          </div>
          <div className='members-filter-modal-field'>
            <Select
              name='tag_filter'
              placeholder='All Tags'
              selectedOption={selectedTagFilter}
              options={tagFilterOptions}
              onChange={(option) => {
                setSelectedTagFilter(option);
              }}
              isError={false}
              useMenuPortal={true}
            />
          </div>
          <div className='members-filter-modal-field'>
            <DatePickerComp
              selectedDate={subscriptionStartDate}
              onDateChange={handleSubscriptionStartDateChange}
              placeholder='Subscription from'
              maxDate={subscriptionEndDate ?? subscriptionToday}
            />
          </div>
          <div className='members-filter-modal-field'>
            <DatePickerComp
              selectedDate={subscriptionEndDate}
              onDateChange={handleSubscriptionEndDateChange}
              placeholder='Subscription to'
              minDate={subscriptionStartDate ?? undefined}
              maxDate={subscriptionToday}
            />
          </div>
          <div className='members-filter-modal-actions'>
            <button
              type='button'

              className='members-reset-button'
              onClick={handleResetFilters}
              disabled={!hasActiveFilters}
            >
              Reset
            </button>
          </div>
        </div>
      </Modal>

      <CSVUploadModal
        isOpen={isCSVUploadModalOpened}
        onClose={() => setIsCSVUploadModalOpened(false)}
        onFileUpload={handleCSVFileUpload}
      />
      {canMergeProfiles && (
        <MergeProfilesModal
          isOpen={isMergeProfilesModalOpened}
          onClose={() => setIsMergeProfilesModalOpened(false)}
          onMergeComplete={() => fetchMembers(searchQuery)}
        />
      )}
      {isCSVPreviewModalOpened && <CSVModal onClose={() => setIsCSVPreviewModalOpened(false)} csvMembers={csvMembers} setCsvMembers={setCsvMembers} setTotalCount={setTotalCount} />}

      {showTabs && (
        <div className="tabs-container">
          <div 
            className={`tab ${activeTab === 'active' ? 'active' : ''}`}
            onClick={() => handleTabChange('active')}
          >
            Active Members{tabCounts.active > 0 ? ` (${tabCounts.active})` : ''}
          </div>
          <div 
            className={`tab ${activeTab === 'disabled' ? 'active' : ''}`}
            onClick={() => handleTabChange('disabled')}
          >
            Disabled Members{tabCounts.disabled > 0 ? ` (${tabCounts.disabled})` : ''}
          </div>

          <div
            className={`tab ${activeTab === 'free' ? 'active' : ''}`}
            onClick={() => handleTabChange('free')}
          >
            Free Members{tabCounts.free > 0 ? ` (${tabCounts.free})` : ''}
          </div>
          <div
            className={`tab ${activeTab === 'all' ? 'active' : ''}`}
            onClick={() => handleTabChange('all')}
          >
            All{tabCounts.all > 0 ? ` (${tabCounts.all})` : ''}
          </div>
          <div
            className={`tab ${activeTab === 'custom-inqurries-blood' ? 'active' : ''}`}
            onClick={() => handleTabChange('custom-inqurries-blood')}
          >
            Customer inquiries blood membership{tabCounts.customInquiriesBlood > 0 ? ` (${tabCounts.customInquiriesBlood})` : ''}
          </div>
          <div
            className={`tab ${activeTab === 'custom-inqurries-body-scan' ? 'active' : ''}`}
            onClick={() => handleTabChange('custom-inqurries-body-scan')}
          >
            Customer inquiries full body scan{tabCounts.customInquiriesBodyScan > 0 ? ` (${tabCounts.customInquiriesBodyScan})` : ''}
          </div>
        </div>
      )}

      {/* Doctor-only tabs */}
      {role === UserRoleEnum.Doctor && (
        <div className="tabs-container">
          <div 
            className={`tab ${doctorTab === 'all-members' ? 'active' : ''}`}
            onClick={() => handleDoctorTabChange('all-members')}
          >
            All Members
          </div>
          <div 
            className={`tab ${doctorTab === 'my-members' ? 'active' : ''}`}
            onClick={() => handleDoctorTabChange('my-members')}
          >
            My Members
          </div>
        </div>
      )}

      <div className="members-table-container">
        {showTabs ? (
          (() => {
            switch (activeTab) {
              case 'active':
                return <MembersTable key={`active-${allMembersKey}`} members={allMembers} setMembers={setAllMembers} userRole={role || undefined} currentTab={activeTab} onMemberStatusChange={() => fetchMembers(searchQuery)} statusFilter={selectedStatusFilter} inchargeFilter={selectedInchargeFilter} planFilter={selectedPlanFilter} doctorFilter={selectedDoctorFilter} tagFilter={selectedTagFilter} subscriptionStartDate={subscriptionStartDateParam} subscriptionEndDate={subscriptionEndDateParam} totalCount={totalCount} searchQuery={searchQuery} />;
              case 'disabled':
                return <MembersTable key={`disabled-${disabledMembersKey}`} members={disabledMembers} setMembers={setDisabledMembers} userRole={role || undefined} currentTab={activeTab} onMemberStatusChange={() => fetchMembers(searchQuery)} statusFilter={selectedStatusFilter} inchargeFilter={selectedInchargeFilter} planFilter={selectedPlanFilter} doctorFilter={selectedDoctorFilter} tagFilter={selectedTagFilter} subscriptionStartDate={subscriptionStartDateParam} subscriptionEndDate={subscriptionEndDateParam} totalCount={totalCount} searchQuery={searchQuery} />;

              case 'free':
                return <MembersTable key={`free-${freeMembersKey}`} members={freeMembers} setMembers={setFreeMembers} userRole={role || undefined} currentTab={activeTab} onMemberStatusChange={() => fetchMembers(searchQuery)} statusFilter={selectedStatusFilter} inchargeFilter={selectedInchargeFilter} planFilter={selectedPlanFilter} doctorFilter={selectedDoctorFilter} tagFilter={selectedTagFilter} subscriptionStartDate={subscriptionStartDateParam} subscriptionEndDate={subscriptionEndDateParam} totalCount={totalCount} searchQuery={searchQuery} />;
              case 'all':
                return <MembersTable key={`all-${allMembersKey}`} members={allMembers} setMembers={setAllMembers} userRole={role || undefined} currentTab={activeTab} onMemberStatusChange={() => fetchMembers(searchQuery)} statusFilter={selectedStatusFilter} inchargeFilter={selectedInchargeFilter} planFilter={selectedPlanFilter} doctorFilter={selectedDoctorFilter} tagFilter={selectedTagFilter} subscriptionStartDate={subscriptionStartDateParam} subscriptionEndDate={subscriptionEndDateParam} totalCount={totalCount} searchQuery={searchQuery} />;
              case 'custom-inqurries-blood':
                return <MembersTable key={`custom-inqurries-blood-${allMembersKey}`} members={allMembers} setMembers={setAllMembers} userRole={role || undefined} currentTab={activeTab} onMemberStatusChange={() => fetchMembers(searchQuery)} statusFilter={selectedStatusFilter} inchargeFilter={selectedInchargeFilter} planFilter={selectedPlanFilter} doctorFilter={selectedDoctorFilter} tagFilter={selectedTagFilter} subscriptionStartDate={subscriptionStartDateParam} subscriptionEndDate={subscriptionEndDateParam} totalCount={totalCount} searchQuery={searchQuery} />;
              case 'custom-inqurries-body-scan':
                return <MembersTable key={`custom-inqurries-body-scan-${allMembersKey}`} members={allMembers} setMembers={setAllMembers} userRole={role || undefined} currentTab={activeTab} onMemberStatusChange={() => fetchMembers(searchQuery)} statusFilter={selectedStatusFilter} inchargeFilter={selectedInchargeFilter} planFilter={selectedPlanFilter} doctorFilter={selectedDoctorFilter} tagFilter={selectedTagFilter} subscriptionStartDate={subscriptionStartDateParam} subscriptionEndDate={subscriptionEndDateParam} totalCount={totalCount} searchQuery={searchQuery} />;
              default:
                return <MembersTable key={`active-${allMembersKey}`} members={allMembers} setMembers={setAllMembers} userRole={role || undefined} currentTab={activeTab} onMemberStatusChange={() => fetchMembers(searchQuery)} statusFilter={selectedStatusFilter} inchargeFilter={selectedInchargeFilter} planFilter={selectedPlanFilter} doctorFilter={selectedDoctorFilter} tagFilter={selectedTagFilter} subscriptionStartDate={subscriptionStartDateParam} subscriptionEndDate={subscriptionEndDateParam} totalCount={totalCount} searchQuery={searchQuery} />;
            }
          })()
        ) : (
          <MembersTable key={`all-${allMembersKey}`} members={allMembers} setMembers={setAllMembers} userRole={role || undefined} doctorTab={role === UserRoleEnum.Doctor ? doctorTab : undefined} statusFilter={selectedStatusFilter} inchargeFilter={selectedInchargeFilter} planFilter={selectedPlanFilter} doctorFilter={selectedDoctorFilter} tagFilter={selectedTagFilter} subscriptionStartDate={subscriptionStartDateParam} subscriptionEndDate={subscriptionEndDateParam} totalCount={totalCount} searchQuery={searchQuery} />
        )}
      </div>
      <div className='members-actions-buttons d-flex align-items-center gap-20'>
        <Button
          width='210px'
          text='Export Members'
          onClick={() => uploadData()}
          isLoading={isExporting}
          className='btn-sm'
        />
        {(role === UserRoleEnum.Admin || role === UserRoleEnum.SuperAdmin) && (
          <Button
            width='210px'
            text='Import users from CSV'
            className='btn-sm'
            onClick={() => {
              setIsCSVUploadModalOpened(true);
            }}
          />
        )}
        {canMergeProfiles && (
          <Button
            width='210px'
            text='Merge Profiles'
            className='btn-sm'
            onClick={() => setIsMergeProfilesModalOpened(true)}
          />
        )}
      </div>
      <MembersModal
        isOpen={isAddMemberModalOpened}
        onClose={() => dispatch(changeModalVisibility(false))}
        onUpdateList={() => fetchMembers(searchQuery)}
      />
    </div>
  );
};

export default Members;
